import * as React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../types';
import { Icon } from '../../icon';
import { Textbox } from '../../textbox';
import { FlexBox } from '../../flex-box';

interface ISearchFieldProps extends IBaseComponentProps<HTMLDivElement> {
    defaultValue?: string;
    isCollapsed: boolean;
    searchPlaceholder?: string;
    onChange(searchText: string): void;
}

const SearchIcon = styled(Icon).attrs({ iconName: 'ap-search2.outline' })`
    fill: ${({ theme: { treeView: { colors } } }) => colors.item.default.mainIcon};
`;

const SearchFieldBase = React.memo((props: ISearchFieldProps) => {
    const { isCollapsed, className, elementRef, defaultValue, onChange, searchPlaceholder = 'Search' } = props;

    return (
        <FlexBox className={className} ref={elementRef} justifyContent="center" alignItems="center">
            {
                isCollapsed
                    ? <SearchIcon iconSize="16" />
                    : <Textbox iconName="ap-search2.outline" gap="8" iconSize="20" defaultValue={defaultValue} placeholder={searchPlaceholder} onValueChange={onChange} allowToClear />
            }
        </FlexBox>
    );
});

SearchFieldBase.displayName = 'SearchField';

export const SearchField = styled(SearchFieldBase).attrs({ className: String('ap-treeView-searchField') })`
    border-bottom: 1px solid ${({ theme: { treeView: { colors } } }) => colors.borderColor};
    margin: ${({ theme: { semantics: { gap } } }) => gap.none};
    padding: ${({ theme: { semantics: { gap } } }) => gap.l};

    ${Textbox} {
        width: 100%;
        border: none;
    }
`;
